import React from "react"

const Component = ({ address }) => {
  return (
    <iframe
      src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d202.38797616648534!2d139.88583701391445!3d35.74570140401898!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601885cf7a21698d%3A0x95fc8d5f7d9c37ed!2z44CSMTMzLTAwNTEg5p2x5Lqs6YO95rGf5oi45bed5Yy65YyX5bCP5bKp77yW5LiB55uu77yU77ySIOe-juWWnOiNmA!5e0!3m2!1sja!2sjp!4v1731391759492!5m2!1sja!2sjp`}
      width="100%"
      height="450"
      frameborder="0"
      style={{ border: 0, marginBottom: "-0.5rem" }}
      allowfullscreen
      loading="lazy"
      title={`Google Map: ${address}`}
    />
  )
}
export default Component
